import { useState } from 'react'
import { GlobalBottomNav } from './global-bottom-nav'
import { Dashboard } from '../dashboard/dashboard'
import { BereicheTab } from '../bereiche/bereiche-tab'
import { ProfilTab } from '../profil/profil-tab'
import { PullToRefresh } from '../components/boothly/pull-to-refresh'

export function AppShell({ initialTab = 'dashboard', authToken, authUser, currentRole, dark, navigate, userStores, landingData, activeSessions, userPreferences, onPreferencesChange, onSelectStore, onCreateStore, onJoinStore, themeMode, onThemeModeChange, onLogout, onRefresh }) {
  const [activeTab, setActiveTab] = useState(initialTab)

  return (
    <div
      className="fixed inset-0 flex flex-col bg-[var(--bg-L0)]"
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)', color: 'var(--label-primary)' }}
    >
      <main className="flex-1 overflow-hidden">
        {activeTab === 'dashboard' && (
          <PullToRefresh onRefresh={onRefresh}>
            <Dashboard
              authToken={authToken}
              userStores={userStores}
              landingData={landingData}
              activeSessions={activeSessions}
              onOpenSettings={() => setActiveTab('profil')}
              onSelectStore={onSelectStore}
              onCreateStore={onCreateStore}
              onJoinStore={onJoinStore}
              dark={dark}
            />
          </PullToRefresh>
        )}
        {activeTab === 'bereiche' && (
          <div style={{ height: '100%', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <BereicheTab
              userStores={userStores}
              landingData={landingData}
              onSelectStore={onSelectStore}
              onCreateStore={onCreateStore}
              onJoinStore={onJoinStore}
              dark={dark}
            />
          </div>
        )}
        {activeTab === 'profil' && (
          <div style={{ height: '100%', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ProfilTab
              authUser={authUser}
              authToken={authToken}
              userStores={userStores}
              userPreferences={userPreferences}
              onPreferencesChange={onPreferencesChange}
              dark={dark}
              themeMode={themeMode}
              onThemeModeChange={onThemeModeChange}
              onLogout={onLogout}
            />
          </div>
        )}
      </main>
      <GlobalBottomNav active={activeTab} onChange={setActiveTab} dark={dark} />
    </div>
  )
}
